export default __webpack_public_path__ + "static/media/frontpageimage.05def9b5.png";